import { IconConsoleRequest } from "@mzc-cloudplex/icons";
import theme from "@styles/theme";
import { StyledRequestTypeFlag } from "./request-type.styled";
import { useMemo } from "react";

const RequestTypeFlag = ({ size }) => {
    const styleBySize = useMemo(() => {
        switch (size) {
            case "small":
                return { width: "20px", height: "16px", iconSize: "12px" };
            case "medium":
            default:
                return { width: "24px", height: "20px", iconSize: "16px" };
        }
    }, [size]);

    return (
        <StyledRequestTypeFlag
            sx={{
                color: theme.palette.constant.white,
                backgroundColor: theme.palette.etc.gray500,
                width: styleBySize.width,
                height: styleBySize.height,
            }}
        >
            <IconConsoleRequest size={styleBySize.iconSize} />
        </StyledRequestTypeFlag>
    );
};

export default RequestTypeFlag;
